<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="12"
          v-for="field in params.fields"
          :key="field.name"
        >
          <v-text-field
            v-if="field.type == 'varchar'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            :aria-label="$t(field.label)"
            outlined
            rounded
            dense
          />
          <v-autocomplete
            v-if="field.type == 'references' && isDeveloperReference(field)"
            v-model="fieldValues[field.name]"
            :items="referencesData"
            item-text="transName"
            :aria-label="$t(field.label)"
            return-object
            outlined
            rounded
            dense
            @change="setSelected"
          />
          <v-select
            v-else-if="field.type == 'references'"
            v-model="fieldValues[field.name]"
            :items="referencesData"
            item-text="transName"
            :aria-label="$t(field.label)"
            return-object
            outlined
            rounded
            dense
            @change="setSelected"
          />
          <v-autocomplete
            v-if="field.type == 'referencesMultiply'"
            v-model="fieldValues[field.name]"
            :items="referencesData"
            item-text="transName"
            :aria-label="$t(field.label)"
            return-object
            multiple
            outlined
            rounded
            dense
            :search-input.sync="search"
            @change="changeReference($event)"
          />
          <template v-if="field.type == 'referencesMultiplyTreeview'">
            <v-text-field
              v-model="searchTreeview"
              :label="$t('Ключевые слова')"
              :aria-label="$t('Ключевые слова')"
              dense
              clearable
              outlined
              rounded
            ></v-text-field>
            <v-treeview
              style="overflow-y: scroll; height: 200px;"
              v-model="fieldValues[field.name]"
              :items="referencesData"
              :search="searchTreeview"
              :label="$t('Ключевые слова')"
              :selection-type="'independent'"
              selectable
            >
            </v-treeview>
          </template>
          <v-textarea
            v-if="field.type == 'textarea'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            :aria-label="$t(field.label)"
            outlined
            rounded
            height="130"
          />
          <ckeditor
            v-if="field.type == 'editor'"
            v-model="editorData"
            :editor="editor"
            :config="editorConfig"
            @ready="prefill(fieldValues[field.name])"
            @change="prefill(editorData)"
          />
          <v-switch
            v-if="field.type == 'switch'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            :aria-label="$t(field.label)"
          />
          <v-col cols="12" md="12">
            <v-btn
              @click="save(field.name, field.type)"
              small
              outlined
              color="primary"
            >
              {{ $t("Сохранить") }}
            </v-btn>
            <v-btn @click="cancel" class="ml-2" small outlined>
              {{ $t("Отмена") }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
//import Search from '@/model/search'
import Npa from '@/store/modules/getNpaData'
// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
  props: {
    params: Object,
    searchTreeview: String
  },
  data: () => ({
    load: false,
    fieldValues: {},
    referencesData: [],
    baseUrl: process.env.VUE_APP_BACK_URL,
    editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        HeadingPlugin,
        HorizontalLine,
        Alignment,
        Table,
        TableToolbar
      ],
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'alignment',
        '|',
        'horizontalLine',
        '|',
        'undo',
        'redo',
        '|',
        'insertTable'
      ],
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      heading: {
        options: [
          {
            model: 'paragraph',
            title: 'Paragraph',
            class: 'ck-heading_paragraph'
          },
          {
            model: 'heading1',
            view: 'h1',
            title: 'Heading 1',
            class: 'ck-heading_heading1'
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'Heading 2',
            class: 'ck-heading_heading2'
          },
          {
            model: 'heading3',
            view: 'h3',
            title: 'Heading 3',
            class: 'ck-heading_heading3'
          }
        ]
      }
    },
    search: '',
    selectId: null,
    selectIds: []
  }),
  created() {
    let self = this

    if (this.params.model) {
      Npa.getNpaDataReferences(this.params.model, this.params.oldParams).then((response) => {
        this.referencesData = response.data
        this.params.fields.forEach((field) => {
          self.$set(self.fieldValues, field.name, field.value)
        })
      })
    } else {
      this.params.fields.forEach((field) => {
        self.$set(self.fieldValues, field.name, field.value)
      })
    }
  },
  methods: {
    isDeveloperReference(field) {
      if (!field) {
        return false
      }

      return field.name === 'developer' || this.params.model === 'refDeveloper'
    },
    setSelected(event) {
      this.selectId = event.id
    },
    changeReference(event) {
      var selectIds = []
      event.forEach(function(value) {
        selectIds.push(value.id)
      })
      this.selectIds = selectIds
      this.search = ''
    },
    save(name, type) {
      if (type == 'references') {
        this.$set(this.fieldValues, name, this.selectId)
      } else if (type == 'referencesMultiply') {
        this.$set(this.fieldValues, name, this.selectIds)
      } else if (type == 'editor') {
        this.$set(this.fieldValues, name, this.editorData)
      }

      Npa.updateNpa(this.fieldValues, this.$route.params.id).then(
        (response) => {
          this.$emit('update-field', {
            status: true,
            fieldName: this.params.name,
            npa: response.data
          })
        }
      )
    },
    cancel() {
      this.$emit('update-field', {
        status: true,
        fieldName: this.params.name
      })
    },
    prefill(val) {
      this.editorData = val
    }
  }
}
</script>
